import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { SkeletonModule } from 'primeng/skeleton';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AsyncPipe } from '@angular/common';
import { EquipmentType } from 'app/modules/dashboard/models/equipment.model';
import {
  Manufacturer,
  ManufacturerEquipment,
} from 'app/modules/browse/models/manufacturer.type';

@Component({
  selector: 'app-equipment-filter-block',
  templateUrl: './equipmentFilterBlock.component.html',
  styleUrls: ['./equipmentFilterBlock.component.scss'],
  standalone: true,
  imports: [TranslateModule, FormsModule, SkeletonModule, AsyncPipe],
})
export class EquipmentFilterBlockComponent implements OnInit, OnDestroy {
  @Input() sportMachine: string[];
  @Input() brandsList$: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  @Input() selectedMachineType: EquipmentType = null;
  @Input() selectedManufacturer: Manufacturer;
  @Input() selectedEquipment: ManufacturerEquipment;

  @Output() inputChanged$: EventEmitter<{
    manufacturer: Manufacturer;
    machineType: EquipmentType;
    equipment: ManufacturerEquipment;
  }> = new EventEmitter<{
    manufacturer: Manufacturer;
    machineType: EquipmentType;
    equipment: ManufacturerEquipment;
  }>(null);

  brandsListLoading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    true
  );
  isDisplayed: boolean = false;
  machineTypeLabels: Record<EquipmentType, string> = {
    home_trainer: 'hometrainer',
    exercise_bike: 'bike',
    treadmill: 'treadmill',
    elliptical: 'elliptical',
    rowing_machine: 'rower',
  };
  subscriptions: Subscription[] = [];

  constructor() {}

  hide(): void {
    if (this.isDisplayed) this.isDisplayed = false;
  }

  show(): void {
    if (!this.isDisplayed) this.isDisplayed = true;
  }

  handleInputChanged(): void {
    this.inputChanged$.emit({
      manufacturer: this.selectedManufacturer,
      machineType: this.selectedMachineType,
      equipment: this.selectedEquipment,
    });
  }

  ngOnInit(): void {
    this.brandsListLoading$.next(true);
    this.brandsList$.subscribe((res: any[]) => {
      if (res.length > 0) this.brandsListLoading$.next(false);
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub: Subscription) => sub.unsubscribe());
  }
}
